(function () {
  'use strict';

  angular.module('imnApp').controller('SystemConfigController', SystemConfigController);

  SystemConfigController.$inject = ['$scope', '$rootScope', '$filter', 'SystemConfigService', 'Authenticate'];

  function SystemConfigController($scope, $rootScope, $filter, SystemConfigService, Authenticate) {
    if (!Authenticate.hasPermission('systemConfiguration')) {
      return;
    }

    var vm = this;
    vm.requestRunning = false;

    var originalData = initializeData();
    vm.config = initializeData();

    vm.dateTime = {
      days: listDays(),
      hours: listHours(),
      minutes: listMinutes()
    };

    vm.save = save;
    vm.cancel = cancel;
    vm.doBackup = doBackup;
    vm.restoreBackup = restoreBackup;
    vm.allowBackup = allowBackup;
    vm.setPeriodDay = setPeriodDay;
    vm.setPeriodHour = setPeriodHour;
    vm.setPeriodMinute = setPeriodMinute;
    vm.setTooltip = setTooltip;
    vm.restoreAppConfigInitial = restoreAppConfigInitial;

    // Call of Service Get User
    vm.requestRunning = true;
    SystemConfigService.getSystemConfig().then(successGet).catch(errorGet);

    function setTooltip() {
      if (!!originalData.backup.path != !!vm.config.backup.path) {
        vm.tooltip = 'backupNotAllowed';
      } else if (!originalData.backup.path) {
        vm.tooltip = 'backupNotAllowedPathEmpty';
      }
    }

    function save() {
      if (vm.formConfig.$valid && !vm.requestRunning) {
        var data = {
          mailServerSmtp: vm.config.smtp.server,
          mailServerPort: vm.config.smtp.port,
          mailServerUseTls: vm.config.smtp.tls,
          mailServerEmail: vm.config.smtp.email,
          mailServerPassword: vm.config.smtp.password,
          userMaxSimultaneousAccess: vm.config.accessControl,

          tftpServerAddress: vm.config.ipTftp,
          fromSig: vm.config.fromSIG,
          sincronizarAlarme: vm.config.sincronizarAlarme,

          systemBackupConfig: {
            path: vm.config.backup.path,
            periodicActive: vm.config.backup.periodic,
            periodicIntervalDay: vm.config.backup.day.value,
            periodicIntervalTime: vm.config.backup.hour
              ? vm.config.backup.hour.value + ':' + vm.config.backup.minute.value
              : null
          }
        };

        vm.requestRunning = true;
        SystemConfigService.updateSystemConfig(data).then(successUpdate).catch(errorUpdate);
      }
    }

    function cancel() {
      vm.config = angular.copy(originalData);
      vm.formConfig.$setPristine();
    }

    function doBackup() {
      if (allowBackup()) {
        var backupPath = vm.config.backup.path;
        var dataAction = {
          action: 'backup',
          methodParam: backupPath,
          methodService: 'doBackup'
        };
        SystemConfigService.confirmationModalConstructor(dataAction, backupPath);
      }
    }

    function restoreBackup() {
      if (allowBackup()) {
        var backupPath = vm.config.backup.path;
        SystemConfigService.listBackupModalConstructor($scope, backupPath);
      }
    }

    function restoreAppConfigInitial(data) {
      var backupPath = vm.config.backup.path;
      var dataAction = {
        action: 'restoreApp',
        methodService: 'restoreAppConfigInitial'
      };
      SystemConfigService.confirmationModalConstructor(dataAction);
      //return $http.post(backupUrl('restoreApp'), {path: data}).then(responseData);
    }

    function allowBackup() {
      return !vm.requestRunning && vm.config.backup.path && vm.config.backup.path == originalData.backup.path;
    }

    function setPeriodDay($select) {
      if (vm.config.backup.day) {
        vm.dateTime.hours = listHours(0);
      } else {
        $select != null ? ($select.activeIndex = 0) : '';
        vm.config.backup.minute = { label: '00min', value: '00' };
        vm.dateTime.hours = listHours(1);
        if (vm.config.backup.hour && vm.config.backup.hour.value == '00') {
          vm.config.backup.hour = '';
        }
      }
    }

    function setPeriodHour($select) {
      if (!vm.config.backup.hours) {
        $select.activeIndex = 0;
      }
    }

    function setPeriodMinute($select) {
      if (!vm.config.backup.minute) {
        $select.activeIndex = 0;
      }
    }

    function successGet(data) {
      vm.requestRunning = false;

      if (data) {
        originalData.smtp.server = data.mailServerSmtp;
        originalData.smtp.port = data.mailServerPort;
        originalData.smtp.tls = data.mailServerUseTls;
        originalData.smtp.email = data.mailServerEmail;
        originalData.smtp.password = data.mailServerPassword;
        originalData.accessControl = data.userMaxSimultaneousAccess;

        originalData.ipTftp = data.tftpServerAddress;
        originalData.fromSIG = data.fromSig;
        originalData.sincronizarAlarme = data.sincronizarAlarme;

        originalData.backup.path = data.systemBackupConfig.path;
        originalData.backup.periodic = data.systemBackupConfig.periodicActive;

        var intervalDay = data.systemBackupConfig.periodicIntervalDay;
        var intervalHour = data.systemBackupConfig.periodicIntervalTime.split(':');

        originalData.backup.day = $filter('filter')(vm.dateTime.days, { value: parseInt(intervalDay) }, true)[0];
        originalData.backup.hour = $filter('filter')(vm.dateTime.hours, { value: intervalHour[0] }, true)[0];
        originalData.backup.minute = $filter('filter')(vm.dateTime.minutes, { value: intervalHour[1] }, true)[0];
        vm.aceiteDoContrato = data.aceiteDoContrato;
        if (!originalData.backup.day) {
          originalData.backup.day = '';
        }

        vm.config = angular.copy(originalData);
        setPeriodDay(null);
        setTooltip();
      }
    }

    function errorGet(response) {
      vm.requestRunning = false;
      SystemConfigService.errorModalConstructor(response, 'get');
    }

    function successUpdate(data) {
      successGet(data);
      SystemConfigService.successModalConstructor('updateConfig');
    }

    function errorUpdate(response) {
      vm.requestRunning = false;
      SystemConfigService.errorModalConstructor(response, 'updateConfig');
    }

    // Helper Functions
    function initializeData() {
      return {
        smtp: {
          server: '',
          port: '',
          tls: false,
          email: '',
          password: ''
        },
        accessControl: '',

        ipTftp: '',
        fromSIG: true,
        sincronizarAlarme: true,

        backup: {
          path: '',
          periodic: '',
          day: '',
          hour: '',
          minute: ''
        }
      };
    }

    $scope.$on(
      '$destroy',
      $rootScope.$on('$translateChangeSuccess', function () {
        vm.dateTime.days = listDays();
        if (vm.config.backup.day) {
          vm.config.backup.day = $filter('filter')(vm.dateTime.days, { value: vm.config.backup.day.value }, true)[0];
        }
      })
    );

    function listDays() {
      var days = [''],
        day,
        suffix = ' ' + $filter('translate')('systemConfig.backupConfig.days');
      for (var i = 1; i < 32; i++) {
        day = (i < 10 ? '0' : '') + i;
        days.push({
          label: day + suffix,
          value: i
        });
      }
      return days;
    }

    function listHours(start) {
      start = start || 0;
      var hours = [''],
        hour;
      for (var i = start; i < 24; i++) {
        hour = (i < 10 ? '0' : '') + i;
        hours.push({
          label: hour + 'h',
          value: hour
        });
      }
      return hours;
    }

    function listMinutes() {
      var minutes = [''],
        minute;
      for (var i = 0; i < 60; i++) {
        minute = (i < 10 ? '0' : '') + i;
        minutes.push({
          label: minute + 'min',
          value: minute
        });
      }
      return minutes;
    }
  }
})();
